// extracted by mini-css-extract-plugin
export default {"login-callback":"styles_login-callback__5wEU3","login-callback-spin":"styles_login-callback-spin__ZiluQ"};